import React from 'react'
import { graphql, navigate } from 'gatsby'
import { Waypoint } from 'react-waypoint'

import ArticleBody from './article-components/articleBody.js'
import Communities from './article-components/communities'
import Footer from './footer'
import Header from './Header'
import Hero from './article-components/hero'
import Layout from '../components/layout'
import Meta from './article-components/meta'
import NextArticle from './article-components/nextArticle'

import articleStyles from './article.module.scss'

// export default ({ data }) => {
class Article extends React.Component {
  constructor(props) {
    super(props)

    this.startCountdown = this.startCountdown.bind(this)
    this.stopCountdown = this.stopCountdown.bind(this)
    this.endCountdown = this.endCountdown.bind(this)
    this.enterTopFold = this.enterTopFold.bind(this)
    this.leaveTopFold = this.leaveTopFold.bind(this)
    this.changeHeaderVisibility = this.changeHeaderVisibility.bind(this)

    this.state = {
      articleFade: true,
      timeTotal: 8,
      timeLeft: 8,
      milisecondsStep: 250,
      belowFold: true,
      headerVisible: false,
      forceMute: false,
    }
  }

  componentDidMount() {
    this.setState({ articleFade: false })
  }

  startCountdown() {
    this.setState({
      interval: setInterval(() => {
        this.setState({
          timeLeft: this.state.timeLeft - this.state.milisecondsStep / 1000,
        })

        if (this.state.timeLeft <= 0) {
          this.endCountdown()
        }
      }, this.state.milisecondsStep),
    })
  }

  endCountdown() {
    clearInterval(this.state.interval)
    this.setState({
      articleFade: true,
      forceMute: true,
      timeLeft: this.state.timeTotal,
    })
    setTimeout(() => {
      document.querySelector('article').scrollIntoView(true)
      navigate(`/${this.props.pageContext.next.slug}`)
    }, 600)
  }

  stopCountdown() {
    clearInterval(this.state.interval)
    this.setState({ timeLeft: this.state.timeTotal })
  }

  enterTopFold() {
    this.setState({ belowFold: false })
  }

  leaveTopFold() {
    this.setState({ belowFold: true })
  }

  changeHeaderVisibility(status) {
    // console.log('change header:', status)
    typeof status === 'boolean' && this.setState({ headerVisible: status })
  }

  render() {
    const { data, location, pageContext } = this.props
    const article = data.strapiArticle
    const next = pageContext.next

    return (
      <>
        {/* WAYPOINT PARA HEADER */}
        <Waypoint
          key={`header-${article.id}`}
          onEnter={() => {
            this.enterTopFold()
            if (this.state.headerVisible === false) {
              setTimeout(() => {
                this.changeHeaderVisibility(true)
              }, 400)
            }
          }}
          onLeave={this.leaveTopFold}
        />
        <Header
          article={article}
          belowFold={this.state.belowFold}
          visible={this.state.headerVisible}
        />

        {/* MIOLO */}
        <Layout
          description={article.lead}
          title={article.title}
          numChapter={article.num_chapter}
          pathName={location.pathname}
        >
          <main
            className={`${articleStyles.main} ${
              this.state.articleFade ? articleStyles.articleFade : ''
            }`}
          >
            <article
              className={`${articleStyles.article} ${
                article.num_chapter === 0 ? articleStyles.home : ''
              }`}
              itemScope
              itemType="http://schema.org/BlogPosting"
            >
              <Hero article={article} forceMute={this.state.forceMute} />

              {/* {article.slug === '/' ? <Communities article={article} /> : ''} */}

              {/* METADADOS */}
              <section className={articleStyles.metaSection}>
                <div className="container">
                  <div className="row">
                    <div
                      id="content"
                      className={`col-xs-12 col-md-3 ${articleStyles.metaColumn}`}
                    >
                      <Meta article={article} />
                    </div>
                  </div>
                </div>
              </section>

              {/* ABRE GRANDE BLOCO DO ARTIGO */}
              <div className={`${articleStyles.articleContainerFluid} `}>
                <div className="container">
                  <div className={`row ${articleStyles.textRow}`}>
                    <div
                      className={`${
                        article.num_chapter === 0
                          ? 'col-md-9 col-md-offset-3'
                          : 'col-md-7 col-md-offset-5'
                      } ${articleStyles.textColumn}`}
                    >
                      {/* PARSE BODY */}
                      {article.body.map((block, i) => (
                        <ArticleBody
                          changeHeaderVisibility={this.changeHeaderVisibility}
                          key={i}
                          block={block}
                          i={i}
                          numChapter={article.num_chapter}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                {/* Se está na home, mostra o mapa */}
                {article.num_chapter === 0 ? (
                  <Communities
                    changeHeaderVisibility={this.changeHeaderVisibility}
                  />
                ) : (
                  ''
                )}
              </div>
              {next && (
                <NextArticle
                  next={next}
                  endCountdown={this.endCountdown}
                  timeTotal={this.state.timeTotal}
                  timeLeft={this.state.timeLeft}
                />
              )}
            </article>
            <Footer hasNext={!!next} hideFooter={article.num_chapter === 0}>
              {next && (
                <div>
                  <Waypoint
                    key={`next-${article.id}`}
                    onEnter={this.startCountdown}
                    onLeave={this.stopCountdown}
                  />
                </div>
              )}
            </Footer>
          </main>
        </Layout>
      </>
    )
  }
}

export default Article

export const query = graphql`
  query ArticleQuery($id: Int!) {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
    strapiArticle(strapiId: { eq: $id }) {
      id
      num_chapter
      title
      slug
      formated_title
      date
      cover_image {
        relativePath
        childImageSharp {
          fluid(maxWidth: 2560, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cover_video_id
      lead
      photographer
      author
      editor
      category {
        name
      }
      strapiId
      body {
        type
        content
        id
        youtube_id
        customClass
        entry {
          legend
          image {
            childImageSharp {
              fluid(maxWidth: 2560, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        fullsize
      }
    }
  }
`
